import { APIModel, APIModelImpl } from '../../uicomponentapimodel';
import { ToneDto } from '../../../../core/dto/tonedto';
import { AddToWishlistDtoImpl } from '../../../../core/dto/wishlist/addtowishlist/addtowishlistdto';
import { AddToWishlistResponse } from '../../../../core/api/wishlist/addtowishlist/addtowishlistresponse';
import { AddToWishlistRequestImpl } from '../../../../core/api/wishlist/addtowishlist/addtowishlistrequest';
import { DeleteToneDtoImpl } from '../../../../core/dto/deletetone/deletetonedto';
import { DeleteToneRequestImpl } from '../../../../core/api/tune/deletetone/deletetonerequest';
import { DeleteToneResponse } from '../../../../core/api/tune/deletetone/deletetoneresponse';

export interface ToneRowAPIModel extends APIModel
{
    addToWishlist(toneDto: ToneDto): void;
    deleteTone(toneDto: ToneDto): void;
}

export class ToneRowAPIModelImpl extends APIModelImpl implements ToneRowAPIModel
{
     addToWishlist(toneDto: ToneDto): void 
     { 
             let addToWishlistDto = new AddToWishlistDtoImpl();
             addToWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
             addToWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
             addToWishlistDto.setIdentifier("AddToWishList");
             addToWishlistDto.setContentId(toneDto.getId());
             addToWishlistDto.setContentName(toneDto.getToneName());
             addToWishlistDto.setPath(toneDto.getToneUrl());
             addToWishlistDto.setPreviewImage(toneDto.getImgPath());
             addToWishlistDto.setAlbum(toneDto.getAlbumName());
             addToWishlistDto.setArtist(toneDto.getArtistName());
             addToWishlistDto.setPrice(String(toneDto.getPrice()));
             addToWishlistDto.setWishlistType("1");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getAddToWishlist()
             .success((addToWishlistResponse: AddToWishlistResponse)=>
             {
                 this.getAPIModelHandler().onSuccess(addToWishlistResponse.getAPIFeature(), 
                 addToWishlistResponse.getDescription(), addToWishlistResponse);
               
              })
             .failure((addToWishlistResponse: AddToWishlistResponse)=>
              {
                this.getAPIModelHandler().onFailure(addToWishlistResponse.getAPIFeature(), 
                addToWishlistResponse.getDescription(), undefined);
              })
             .execute(new AddToWishlistRequestImpl(addToWishlistDto));
     } 

     deleteTone(toneDto: ToneDto): void 
     {
        /* this.getAPIModelHandler().onSuccess("", 
            "", ""); */

            let deleteToneDto = new DeleteToneDtoImpl();
            deleteToneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            deleteToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
            deleteToneDto.setToneId(toneDto.getId());
            deleteToneDto.setPackName(this.getContext().getUserContext().getPackName());
   
            this.getAPIProcesssorFactory().getToneProcessorFactory()
            .getDelteTone()
            .success((deleteToneResponse: DeleteToneResponse)=>
            {
                this.getAPIModelHandler().onSuccess(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), deleteToneResponse);
              
             })
            .failure((deleteToneResponse: DeleteToneResponse)=>
             {
               this.getAPIModelHandler().onFailure(deleteToneResponse.getAPIFeature(), 
               deleteToneResponse.getDescription(), undefined);
             })
            .execute(new DeleteToneRequestImpl(deleteToneDto));    
     }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowapimodel.tsx